import TagManager from 'react-gtm-module'

import { CampaignPlatformTypeEnum, CampaignTypeEnum } from 'src/Types/campaigns'
import { ID } from 'src/Types/common'
import { TagManagerEnum } from 'src/Constants/enums'

import { EventNameEnum, EventTypeEnum } from '../tagManagerEnums'

export const languageAddedEvent = ({
  campaignType,
  languageId,
  languageName,
  platformName,
  userId,
  campaignId,
  languageOptions,
}: {
  campaignType: string | CampaignTypeEnum
  languageId?: string
  languageName?: string
  platformName?: string
  userId?: string
  campaignId?: number | string
  languageOptions?: boolean
}): void => {
  TagManager.dataLayer({
    dataLayer: {
      event: EventTypeEnum.LanguagesAdded,
      event_name: EventNameEnum.LanguagesAdded,
      'campaign-type': campaignType,
      'campaign-platform': platformName,
      'track-platform': platformName,
      'campaign-id': campaignId,
      userID: userId,
      'language-name': languageName,
      'language-id': languageId,
      ...(platformName === CampaignPlatformTypeEnum.SPOTIFY
        ? {
            language_options: languageOptions
              ? TagManagerEnum.WIDER_LANGUAGES_MATCHING
              : TagManagerEnum.SELECTED_LANGUAGES_ONLY,
          }
        : {}),
    },
  })
}

export const changedLanguageOptionsEvent = ({
  isFirstCampaign,
  campaignNumber,
  userId,
  campaignId,
  languageOptions,
}: {
  isFirstCampaign: boolean
  campaignNumber?: number
  userId?: ID | null
  campaignId: string | number
  languageOptions: boolean
}): void => {
  TagManager.dataLayer({
    dataLayer: {
      event: EventTypeEnum.GA_EVENT,
      event_params: {
        event_name: EventNameEnum.ChangedLanguageOptions,
        campaign_platform: CampaignPlatformTypeEnum.SPOTIFY,
        track_platform: CampaignPlatformTypeEnum.SPOTIFY,
        campaign_type:
          (isFirstCampaign && campaignNumber === 1) || !userId
            ? CampaignTypeEnum.FIRST
            : CampaignTypeEnum.NEW,
        campaign_number: campaignNumber || 1,
        campaign_id: campaignId,
        language_options: languageOptions
          ? TagManagerEnum.WIDER_LANGUAGES_MATCHING
          : TagManagerEnum.SELECTED_LANGUAGES_ONLY,
      },
      user_properties: {
        ...(userId ? { user_id: userId } : {}),
        account_type: 'artist',
      },
    },
  })
}
